import { cnpjDigit as verifierDigit } from './modulo11'

const CNPJ_REGEX = /^[A-Z0-9]{12}\d{2}$/

function strip(value) {
  if (typeof value !== 'string') return ''
  return value.replace(/[./-]/g, '').toUpperCase()
}

export default function isValid(value) {
  if (!value) return true

  const cnpj = strip(value)
  if (!CNPJ_REGEX.test(cnpj)) return false

  let document = cnpj.slice(0, 12)
  document += verifierDigit(document)
  document += verifierDigit(document)

  return document.slice(-2) === cnpj.slice(-2)
}
